<template>
  <div ref="mapContainer" class="map"></div>
</template>

<script>
export default {
  name: 'Map',
  data() {
    return {
      map: null,
      marker: null
    }
  },
  mounted() {
    this.initMap()
  },
  beforeDestroy() {
    if (this.map) {
      this.map.destroy()
    }
  },
  methods: {
    initMap() {
      // 等待腾讯地图API加载完成
      if (typeof TMap === 'undefined') {
        setTimeout(() => this.initMap(), 100)
        return
      }

      const center = new TMap.LatLng(31.690783, 120.325674)
      
      // 腾讯地图GL API的配置选项
      const mapOptions = {
        center: center,
        zoom: 20,
        enableScrollWheelZoom: true
      };
      
      // 腾讯地图GL API可能不需要mapTypeId，或者使用不同的方式
      // 如果MapTypeId存在，则尝试添加地图类型
      try {
        if (TMap.MapTypeId) {
          if (TMap.MapTypeId.NORMAL) {
            mapOptions.mapTypeId = TMap.MapTypeId.NORMAL;
          } else if (TMap.MapTypeId.ROADMAP) {
            mapOptions.mapTypeId = TMap.MapTypeId.ROADMAP;
          }
        }
      } catch (e) {
        // MapTypeId不存在，忽略此参数
        console.log('MapTypeId不可用，使用默认地图类型');
      }
      
      this.map = new TMap.Map(this.$refs.mapContainer, mapOptions)

      // 创建标记点
      this.marker = new TMap.MultiMarker({
        map: this.map,
        styles: {
          default: new TMap.MarkerStyle({
            width: 25,
            height: 35,
            anchor: { x: 12, y: 35 },
            src: 'https://mapapi.qq.com/web/lbs/javascriptGL/demo/img/markerDefault.png'
          })
        },
        geometries: [{
          id: 'marker1',
          styleId: 'default',
          position: center
        }]
      })
    }
  }
}
</script>

<style>
.map {
  width: 100%;
  height: 470px;
}
/* 去除腾讯地图版权信息 */
::v-deep .tmap-copyright {
  display: none !important;
}
</style>
